<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>組織・所属変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">中断する</button>
        <button v-if="reserve.status==0" id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>開始日</label>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <input type="date" class="form-control" v-model="reserve.startAt" v-bind:min="minDay" max="2100-12-31">
                </div>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>変更内容</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="reserve.operation" disabled>
                  <option value="1">組織変更</option>
                  <option value="2">所属変更</option>
                </select>
              </div>
            </div>  
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">次へ</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      organizationOptions: [],
      historyId: 0,
      minDay: '',
      reserve: {
        hospitalId: '',
        startAt: '',
        operation: 1,
        status: 1
      }
    }
  },
  created() {
    var tomorrow = this.minDay
    tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.minDay = this.formatDate(tomorrow);
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var reserveId = this.$route.params.id;
        axios.get("/api/reserve/" + reserveId, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.reserve = {
            hospitalId: response.data.data.reserve.hospitalId,
            startAt: response.data.data.reserve.startAt,
            operation: response.data.data.reserve.operationValue,
            status: response.data.data.reserve.statusValue,
          }
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var reserveId = this.$route.params.id;
          axios.put("/api/reserve/" + reserveId, {
              reserve: this.reserve
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              // alert('更新されました。');
              this.next()
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var reserveId = this.$route.params.id;
          var hospitalId = this.$store.getters.hospital.id
          axios.delete("/api/reserve/" + hospitalId + '/' + reserveId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。')
              this.back()
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    formatDate(tomorrow){
      var y = tomorrow.getFullYear();
      var m = ('00' + (tomorrow.getMonth()+1)).slice(-2);
      var d = ('00' + tomorrow.getDate()).slice(-2);
      var result = y +'-' + m + '-' + d;
      return result;
    },
    next() {
      var reserveId = this.$route.params.id;
      if(this.reserve.operation == 1) {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/orglist/'+reserveId))
      } else {
        if(this.$store.getters.organization){
          this.historyId = this.$store.getters.organization.historyId
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/belonglist/'+this.historyId+'/'+reserveId))
        }
      }
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/index'))
    },
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>